import { AddDirectorFormState } from './types';

// 26 predefined designations for a manually-added director. FE-only — a typed "Add Other"
// value (via CircularSelect) is saved on that director record alone and is never added to
// this list. Do NOT reuse the unrelated Admin/Team-Member `DESIGNATION` in commonConstants.ts
// — that enum governs platform user roles, not director designations.
export const DIRECTOR_DESIGNATIONS = [
    'Co-Founder & CEO',
    'Ceo',
    'CEO (KMP)',
    'Managing Director',
    'DIRECTOR, CEO (KMP)',
    'Director',
    'Cfo',
    'CFO (KMP)',
    'Director Appointed in Casual Vacancy',
    'Whole-Time Director',
    'WHOLETIME DIRECTOR',
    'Nominee Director',
    'Alternate Director',
    'Additional Director',
    'Designated Partner',
    'Company Secretary',
    'Manager',
    'Partner',
    'Authorised Representative',
    'Officer in Default',
    'Nodal Officer',
    'Beneficial Owner',
    'Nominee',
    'Individual Promoter',
    'Owner',
    'Corporate Guarantor',
] as const;

export const EMPTY_FORM: AddDirectorFormState = { name: '', pan: '', din: '', phone: '', email: '', designation: '' };
